import React from 'react'
import QuestionCard from './QuestionCard'
import RadioOption from './RadioOption'

interface SectionProps {
  formData: Record<string, any>
  updateField: (field: string, value: any) => void
}

/**
 * Section G: Closing (Q21-Q22)
 *
 * Collects opt-in for the full report (with email capture) and
 * interest in a personalized AI maturity analysis.
 */
const SectionG: React.FC<SectionProps> = ({ formData, updateField }) => {
  return (
    <div className="flex flex-col gap-6">

      {/* Q21 */}
      <QuestionCard
        title="Quer receber o relatório completo com os resultados?"
        required
      >
        <RadioOption
          name="q21"
          value="sim"
          label="Sim"
          selected={formData.q21 === 'sim'}
          onChange={(value) => updateField('q21', value)}
        />
        <RadioOption
          name="q21"
          value="nao"
          label="Não, obrigado"
          selected={formData.q21 === 'nao'}
          onChange={(value) => updateField('q21', value)}
        />
      </QuestionCard>

      {/* Email input — shown only when the respondent wants the report */}
      {formData.q21 === 'sim' && (
        <div className="mb-8 -mt-4">
          <label
            htmlFor="q21_email"
            className="block text-sm font-medium text-slate-700 mb-2"
          >
            Seu melhor e-mail
          </label>
          <input
            type="email"
            id="q21_email"
            value={formData.q21_email ?? ''}
            onChange={(e) => updateField('q21_email', e.target.value)}
            placeholder="email@exemplo.com"
            className="w-full px-4 py-3 text-sm border border-slate-200 rounded-lg bg-background
              focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent
              placeholder:text-slate-400"
          />
        </div>
      )}

    </div>
  )
}

export default SectionG
